import { Field } from "typegraph";

export default class CountResult {

	@Field()
	public count: number = 0;

}



// WEBPACK FOOTER //
// ./src/common/entities/CountResult.ts